import { createFcmExperimentsContext } from 'src/app/shared/contexts/experiment';
import type { LoadedStateData } from 'src/app/shared/utils/async';

import { FCM_EXPERIMENT_PSF_TO_SAP_LOCAL_FLOW } from './config';

export const {
	FcmExperimentsContext: StartAPetitionPageFcmExperimentsContext,
	FcmExperimentsProvider: StartAPetitionPageFcmExperimentsContextProvider,
	useFcmExperiments: useStartAPetitionPageFcmExperiments,
	useAsyncFcmExperiments: useAsyncStartAPetitionPageFcmExperiments,
	prefetchFcmExperiments: prefetchStartAPetitionPageFcmExperiments,
} = createFcmExperimentsContext({
	name: 'StartAPetitionPageFcmExperimentsContext',
	dataProperty: 'pageFcmExperiments',
	configs: {
		psfToSapLocalFlowExperiment: FCM_EXPERIMENT_PSF_TO_SAP_LOCAL_FLOW,
	},
	prefetch: true,
});

export type StartAPetitionPageFcmExperimentsState = ReturnType<typeof useAsyncStartAPetitionPageFcmExperiments>;
export type StartAPetitionPageFcmExperiments = LoadedStateData<StartAPetitionPageFcmExperimentsState>;
